import s, { useState as w, useMemo as M } from "react";
import { DateTime as S } from "luxon";
import { useTranslation as O } from "react-i18next";
import { ScopeModel as P } from "../../../../../../features/api/models/scope/scope.model.js";
import R from "../../../hooks/customization/useCustomization.js";
import { Selector as k } from "../../../../../../features/common/components/forms/Selector/Selector.js";
import { tint as Z } from "../../../../../../../common/libs/tint.js";
import { useOrdering as $ } from "../context.js";
import n from "./steps.module.scss.js";
import A from "../../../hooks/backend/useRestaurantHours.js";
import { convertDateToLabel as F } from "../../../../../../utils.js";
function ee() {
  var T;
  const { t: a } = O(), {
    currentStep: c,
    setFormValue: m,
    form: d,
    setStep: B,
    back: g
  } = $(), [u, b] = w(null), {
    isLoading: p,
    data: h,
    isSuccess: v,
    mutate: L
  } = A(), {
    configuration: e,
    getTextTranslations: x
  } = R(), o = x("popup"), y = Z(5e-3, (e == null ? void 0 : e.design.colors.general.highlightBackground) ?? "#222"), C = M(
    () => c.data.restaurants.reduce((t, r) => ({
      ...t,
      [r.id]: r
    }), {}),
    [c.data.restaurants]
  ), E = c.data.availability.map((t) => {
    const [r] = t.scope.locations ?? [], l = C[r];
    return {
      value: t,
      label: F(t.date, a("today"), a("tomorrow"), l == null ? void 0 : l.timezone)
    };
  }), _ = (T = h == null ? void 0 : h.availability) == null ? void 0 : T.map((t) => {
    const [r] = t.scope.locations ?? [], l = C[r], i = (l == null ? void 0 : l.timezone) || "UTC", f = S.fromSeconds(t.time).setZone(i), z = S.fromSeconds(t.time + t.time_interval).setZone(i), D = `
      ${f.toLocaleString({ hour: "2-digit", minute: "2-digit" })} -
      ${z.toLocaleString({ hour: "2-digit", minute: "2-digit" })}
    `;
    return {
      value: {
        availability: t,
        restaurant: l
      },
      label: D
    };
  }), I = (t) => {
    var r, l, i;
    m("day", t.value.date), m("hour", void 0), b(null), L({
      date: t.value.date,
      address: {
        address: ((r = d.place) == null ? void 0 : r.formattedAddress) ?? "",
        latitude: ((l = d.place) == null ? void 0 : l.lat) ?? 0,
        longitude: ((i = d.place) == null ? void 0 : i.long) ?? 0
      },
      serviceType: c.data.service,
      scope: new P(
        void 0,
        t.value.scope.locations ?? []
      )
    });
  }, N = (t) => {
    m("hour", t.value.availability.time), b(t);
  }, H = async () => {
    const {
      service: t
    } = c.data;
    !d.day || !d.hour || !u || B({
      name: "restaurant-redirection",
      data: {
        service: t,
        restaurant: u.value.restaurant,
        now: !1
      }
    });
  };
  return /* @__PURE__ */ s.createElement("div", { "data-testid": "time-selector-step" }, /* @__PURE__ */ s.createElement("div", { className: n.formTitle }, /* @__PURE__ */ s.createElement("i", { onClick: () => g(), className: "lni lni-chevron-left" }), (o == null ? void 0 : o.datetime_title) || a("shopLanding.datetime.title")), /* @__PURE__ */ s.createElement(
    k,
    {
      onChange: (t) => I(t),
      isDisabled: p,
      className: n.selector,
      textColor: e == null ? void 0 : e.design.colors.general.highlightText,
      labelColor: e == null ? void 0 : e.design.colors.general.highlightHighlight,
      backgroundColor: y,
      label: (o == null ? void 0 : o.day) || a("day"),
      placeholder: (o == null ? void 0 : o.day_placeholder) || a("shopLanding.datetime.dayPlaceholder"),
      options: E,
      testId: "day-selector"
    }
  ), /* @__PURE__ */ s.createElement(
    k,
    {
      value: u,
      onChange: (t) => N(t),
      isDisabled: p || !v,
      className: n.selector,
      textColor: e == null ? void 0 : e.design.colors.general.highlightText,
      labelColor: e == null ? void 0 : e.design.colors.general.highlightHighlight,
      backgroundColor: y,
      label: (o == null ? void 0 : o.hour) || a("hour"),
      placeholder: (o == null ? void 0 : o.hour_placeholder) || a("shopLanding.datetime.hourPlaceholder"),
      options: _,
      testId: "time-selector"
    }
  ), /* @__PURE__ */ s.createElement("div", { className: n.buttonContainer }, /* @__PURE__ */ s.createElement(
    "button",
    {
      style: {
        backgroundColor: e == null ? void 0 : e.design.colors.general.secondaryButtonBackground,
        color: e == null ? void 0 : e.design.colors.general.secondaryButtonText
      },
      className: n.button,
      type: "button",
      onClick: () => g()
    },
    (o == null ? void 0 : o.cancel_btn) || a("shopLanding.datetime.cancelBtn")
  ), /* @__PURE__ */ s.createElement(
    "button",
    {
      disabled: p || !v || !d.hour,
      style: {
        backgroundColor: e == null ? void 0 : e.design.colors.general.primaryButtonBackground,
        color: e == null ? void 0 : e.design.colors.general.primaryButtonText
      },
      className: n.button,
      type: "button",
      onClick: () => H()
    },
    (o == null ? void 0 : o.program_btn) || a("shopLanding.datetime.programBtn")
  )));
}
export {
  ee as default
};
//# sourceMappingURL=TimeSelectorStep.js.map
